module.exports = __webpack_public_path__ + "img/interior_3.7c436ddf.jpg";